import { getEnvironment } from '../../../utils/request';

export const formDataKeyMapping = {
  defectWebform: 'defectWebform',
  defectCategory: 'defectCategory',
  priority: 'priority',
  issueSummary: 'reportIssueSummary',
  webformOrderID: 'defectWebformOrderId',
  errorMessage: 'reportErrorMessage',
  stepsToReplicate: 'replicateProblem',
  attachment: 'reportIssueAttachments'
};

export const initialFieldData = {
  defectWebform: '',
  defectCategory: '',
  priority: '',
  issueSummary: '',
  webformOrderID: '',
  errorMessage: '',
  stepsToReplicate: '',
  attachment: ''
};

const caseAssigneeMapping = {
  dev: {
    case1: { assignee: 'mubashar.hussain@mobilelive.ca', userId: 269 },
    case2: { assignee: 'aneeq.khan@mobilelive.ca', userId: 147 },
    case3: { assignee: 'annas.salman@mobilelive.ca', userId: 270 },
    case4: { assignee: 'mubashar.hussain@mobilelive.ca', userId: 269 }
  },
  qa: {
    case1: { assignee: 'zubair.safdar@mobilelive.ca', userId: 23149 },
    case2: { assignee: 'muhammad.tauqeer+admin@mobilelive.ca', userId: 6541 },
    case3: { assignee: 'mubashar.hussain@mobilelive.ca', userId: 3508 },
    case4: { assignee: 'muhammad.tauqeer+admin@mobilelive.ca', userId: 6541 }
  },
  prod: {
    case1: { assignee: 'avani.gautam@telus.com', userId: 6364 },
    case2: { assignee: 'maery.songvilay@telus.com', userId: 10529 },
    case3: { assignee: 'orsolya.gyorgy@telus.com', userId: 15583 },
    case4: { assignee: 'haider.baig@telus.com', userId: 13170 }
  }
};

/**
 * This functions returns user to whom the defect should be assigned
 * depending on certain criteria
 */
export const getDefectAssignee = (fieldData, translations, userId) => {
  const {
    reportAnIssue: {
      form: {
        labelDefectWebformOptionBusinessConnect,
        labelDefectWebformOptionWirelineSecurity,
        labelDefectWebformOptionWireless,
        labelDefectCategoryOptionOffersPricing,
        labelDefectCategoryOptionUserInfo
      }
    }
  } = translations;
  const { name: envName } = getEnvironment();
  const { defectWebform, defectCategory } = fieldData;
  const result = {
    assignee: '',
    adminUpdate: false
  };
  const isValidWebform =
    defectWebform === labelDefectWebformOptionBusinessConnect ||
    defectWebform === labelDefectWebformOptionWirelineSecurity;

  if (!['dev', 'qa', 'prod'].includes(envName)) return result;

  /**
   * CASE 4 - Category is "User Info" for all Webforms (user access/updates)
   * Haider handles all access related issues including wireless
   * This case is checked first as it has highest priority
   */
  if (defectCategory === labelDefectCategoryOptionUserInfo) {
    result.assignee = caseAssigneeMapping[envName].case4.assignee;
    result.adminUpdate = userId !== caseAssigneeMapping[envName].case4.userId;
    return result;
  }

  /**
   * CASE 1 - Webform is "Wireless" (behavioral issues - not access related)
   * Avani handles wireless issues that are not access related
   */
  if (defectWebform === labelDefectWebformOptionWireless) {
    result.assignee = caseAssigneeMapping[envName].case1.assignee;
    result.adminUpdate = userId !== caseAssigneeMapping[envName].case1.userId;
    return result;
  }

  /**
   * CASE 2 - Webform is "Wireline/Security OR Business Connect" & Category is "Offer & Pricing"
   */
  if (
    isValidWebform &&
    defectCategory === labelDefectCategoryOptionOffersPricing
  ) {
    result.assignee = caseAssigneeMapping[envName].case2.assignee;
    result.adminUpdate = userId !== caseAssigneeMapping[envName].case2.userId;
    return result;
  }

  /**
   * CASE 3 - Webform is Not "Wireless"/ "Wireline / Business Connect And Category is not Offer & Pricing / User Info"
   */
  if (
    !(
      isValidWebform &&
      defectCategory === labelDefectCategoryOptionOffersPricing
    ) &&
    defectWebform !== labelDefectWebformOptionWireless &&
    defectCategory !== labelDefectCategoryOptionUserInfo
  ) {
    result.assignee = caseAssigneeMapping[envName].case3.assignee;
    result.adminUpdate = userId !== caseAssigneeMapping[envName].case3.userId;
  }

  return result;
};
